<template>
  <div class="hire">
    <div>
      <section class="contact">
        <div class="container">
          <div class="grid">
            <h2>Ready to Turn UX Challenges into Efficiency Gains</h2>
            <div class="contact-content">
              <p>
                Need a Lead Designer? Whether you’re looking to hire or just
                want to brainstorm your next big idea, drop me a message and
                let's create something unforgettable!
              </p>
              <div class="contact-button">
                <a
                  target="_blank"
                  href="https://calendar.google.com/calendar/render?action=TEMPLATE&text=Up%20for%20chit%20chat?&add=ujjwallverma@gmail.com"
                  class="button-email"
                  >Let's Talk!</a
                >
                <a href="/img/resume.pdf" target="_blank" class="button-call"
                  >Download Resume</a
                >
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  props: ["image"],
};
</script>
